import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AbstractCrudService } from '../../shared/abstract-crud.service';
import { BackendReminder } from '../reminder-fields.type';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class ReminderCrudService extends AbstractCrudService<BackendReminder> {
/**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'reminders';

  constructor(http: HttpClient, private authService: AuthService) {
    super(http);
  }

  /**
   * Get Reminder for user currently logged in
   */
  public async getReminders(): Promise<BackendReminder[]> {
    const filteringProperties = {
      userId: this.authService.getSubject()
    };
    const serviceAnswer = await this.filter(filteringProperties);
    return (serviceAnswer.data || [])
      .filter(backendReminder => !!backendReminder.alarmingTime) // Validate reminders (alarmingTime required for now)
      .map((backendReminderFields: any): BackendReminder => {
        // Convert date fields from string
        return {
          ...backendReminderFields,
          alarmingTime: backendReminderFields.alarmingTime ? new Date(backendReminderFields.alarmingTime) : null,
          createdAt: backendReminderFields.createdAt ? new Date(backendReminderFields.createdAt) : null,
          updatedAt: backendReminderFields.updatedAt ? new Date(backendReminderFields.updatedAt) : null,
          deletedAt: backendReminderFields.deletedAt ? new Date(backendReminderFields.deletedAt) : null,
        };
      });
  }
}
